export default "__VITE_ASSET__0d457322__"